module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAJFBMVEUAAAAAus8AvtEAv8wAvc4Avc4Avc4Avc0Avc4Avc6A3uf///8VeMBGAAAACXRSTlMAJScore/x8vOThETtAAAAY0lEQVQoz2NgoAlgdJuJBFIEwIKqM1FAEFjQE1VwClgwE1VwBlgQyNiNDKgkCBGG2jS4BXetxiK4cham4K6ZM1djCK6cOXMWhiASGKyCWBMD1mRjiioYDBZkckcWK1GgTYIHAJk6OKdmpZWRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/home/wodekc@2x.png
// module id = 8cuT
// module chunks = 0